import store from '@/store/index';
import { UserState } from '@/store/types';
import { IRelaysChangedEvent, RelaysChangedEvent } from '../../apis/DeviceApi';
import IEventApi from './IEventApi';
import Logger from '@/common/logging/Logger';


export default class XamarinEventApi implements IEventApi {
    private logger = Logger('event-api');

    private eventSubscribers: {[eventName: string]: Array<((arg: any) => void)>} = {};

    public start(): void {
        /* Do nothing */
    }

    public stop(): void {
        /* Do nothing */
    }

    public onEvent<T>(eventName: string, callback: (event: T) => any): void {
        let subscribers = this.eventSubscribers[eventName];
        if (!subscribers) {
            this.eventSubscribers[eventName] = subscribers = new Array();
        }
        subscribers.push(callback);
    }

    public unsubscribeOnEvent<T>(eventName: string, callback: (event: T) => any): void {
        let subscribers = this.eventSubscribers[eventName];
        if (!subscribers) {
            this.eventSubscribers[eventName] = subscribers = new Array();
        }
        for (let i = 0; i < subscribers.length; i++) {
            if (subscribers[i] === callback) {
                subscribers.splice(i, 1);
                break;
            }
        }
    }

    public subscribe(deviceNumber: string): void {
        /* Allways subscribed */
    }

    public newEvent(incomming: {type: string, event: any}) {
        // console.log('new event', incomming);
        this.logger.debug(`new event ${incomming.type}: ${JSON.stringify(incomming.event)}`);
        const subscribers = this.eventSubscribers[incomming.type];
        if (subscribers) {
            for (const subscriber of subscribers) {
                subscriber(incomming.event);
            }
        }
    }

}


